import { publicComponentOption } from "dependencies/base"
import { toSelectOpt } from "utils"
const optDes = {
  ...publicComponentOption,
  content: "内容",
  openBlankPage: "新开页面跳转",
  linkUrlVal: "二维码值",
  accessRulers: "访问规则",
  bgColor: "背景颜色",
  codeColor: "二维码颜色",
  opacity: "透明度",
  "animateSets.animateType": "动画类型",
  "animateSets.animateDirection": "动画方向",
  "animateSets.animateDuration": "动画持续时间"
}
export const getOptDes = toSelectOpt.bind(this, optDes)
